import React, {useEffect, useState} from 'react';
import "./transcription.scss";
import PropTypes from "prop-types";
import {ReactComponent as SeperatorIcon} from "../../assets/icons/Seperator.svg";
import {speakerColoredGradients} from "../Attendees/AvatarName";
import parse from 'html-react-parser';
import MeetingDetailsControls from "../MeetingDetailsControls/MeetingDetailsControls";
import { Element, scroller } from "react-scroll";

const Transcription = ({messages, currentAudioTime, showAutoScroll, attendeesIdsWithIndex}) => {

    const [autoScrollOn, setAutoScrollOn] = useState(showAutoScroll);
    const [regex, setRegex] = useState(null);
    const [currentSearchIndex, setCurrentSearchIndex] = useState(null);
    
    useEffect(() => {
        if (autoScrollOn) {
            const message = messages.reduce((acc, message) => {
                if (message && message.timeOffset <= currentAudioTime) {
                    if (!acc || acc.timeOffset < message.timeOffset) {
                        return message;
                    }
                }
                return acc;
            }, null);
    
            if (message && message.id) {
                scrollToMessageId(message.id);
            }
        }
    }, [currentAudioTime, autoScrollOn, messages]);
    
    const handleAutoScrollToggle = () => {
        setAutoScrollOn(autoScrollOn => !autoScrollOn);
    }
    const scrollToMessageId = (messageId) => {
        scroller.scrollTo(messageId, {
            containerId: "transcript-scroll-container",
            duration: 600,
            smooth: true,
        });
    }

    const [searchKeywordMatchingIndexes, setSearchKeywordMatchingIndexes] = useState([]);

    const handleSearchKeywordChange = (searchString) => {
        const regex = new RegExp("(" + searchString + ")", "gi");
        setRegex(regex);

        const matchingIndexes = messages.reduce((acc, {text}, index) => {
            return text.match(regex) === null ? acc : [...acc, index];
        }, []);

        setSearchKeywordMatchingIndexes(matchingIndexes);
        if(matchingIndexes.length > 0) {
            setCurrentSearchIndex(0);
            scrollToMessageId(messages[matchingIndexes[0]].id);
        } else {
            setCurrentSearchIndex(null);
        }
    }

    const goToNextSearchResult = () => {
        if(currentSearchIndex < searchKeywordMatchingIndexes.length - 1) {
            const currentIndex = currentSearchIndex + 1;
            setCurrentSearchIndex(currentIndex);
            scrollToMessageId(messages[searchKeywordMatchingIndexes[currentIndex]].id);
        }
    }
    const goToPreviousSearchResult = () => {
        if(currentSearchIndex > 0) {
            const currentIndex = currentSearchIndex - 1;
            setCurrentSearchIndex(currentIndex);
            scrollToMessageId(messages[searchKeywordMatchingIndexes[currentIndex]].id);
        }
    }

    return <div>
        <MeetingDetailsControls
            onSearchKeywordChange={handleSearchKeywordChange}
            currentSearchIndex={currentSearchIndex}
            totalMatchesFound={searchKeywordMatchingIndexes.length}
            goToNextSearchedItem={goToNextSearchResult}
            goToPreviousSearchedItem={goToPreviousSearchResult}
            showAutoScroll={showAutoScroll}
            onAutoScrollToggleChange={handleAutoScrollToggle}/>
        <div className={"messages-container"} id={"transcript-scroll-container"} style={{maxHeight: 600, overflowY: "scroll"}}>
        {
            messages.map(({name,text,timeOffsetToShow, id, from }, index) => {
                const highlightedText = text.replace(regex,`<span class='${searchKeywordMatchingIndexes[currentSearchIndex] === index ? 'highlight' : ''}'>$1</span>`);

                return <Element key={id} name={id}>
                    <div className={"message-container"}>
                        <div className="metadata" style={name ? {} : { gap: '0px' }}>
                            {name ? <p className={"speaker-name"} style={{
                                background: speakerColoredGradients[attendeesIdsWithIndex[from.id]],
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent"
                            }}>{name}</p> : <p className={"speaker-name"}></p>}
                            {name && <SeperatorIcon/>}
                            <p className={"time-offset"}>{timeOffsetToShow}</p>
                        </div>
                        <p className={"transcription"}>
                            {parse(highlightedText)}
                        </p>
                    </div>
                </Element>
            }
            )
        }
    </div>
    </div>
};

export default Transcription;

Transcription.prototype = {
    messages: PropTypes.array,
    currentAudioTime: PropTypes.number,
    showAutoScroll: PropTypes.number,
    attendeesIdsWithIndex: PropTypes.array
}